import Vue from "vue";
import VueRouter from "vue-router";
import Intro from "../views/Intro.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Intro",
    component: Intro,
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home1.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/roadside",
    name: "Roadside",
    component: () => import("../views/Roadside.vue"),
  },
  {
    path: "/sos/:routeBoolean",
    name: "SOS",
    component: () => import("../views/Sos.vue"),
  },
  {
    path: "/crash",
    name: "Crash",
    component: () => import("../views/Crash.vue"),
  },
  {
    path: "/call/:name",
    name: "Call",
    component: () => import("../views/Call.vue"),
  },
  {
    path: "/nav",
    name: "Nav",
    component: () => import("../views/Nav.vue"),
  },
  {
    path: "/nav-annarbor",
    name: "NavAA",
    component: () => import("../views/NavAnnArbor.vue"),
  },
  {
    path: "/onstar",
    name: "Onstar",
    component: () => import("../views/Onstar.vue"),
  },
  {
    path: "/locked/:routeBoolean",
    name: "Locked",
    component: () => import("../views/Locked.vue"),
  },
  {
    path: "/directions-grandblvd",
    name: "Directions Grand Blvd",
    component: () => import("../views/DirectionsGrandBlvd.vue"),
  },
  {
    path: "/directions-annarbor",
    name: "Directions Ann Arbor",
    component: () => import("../views/DirectionsAnnArbor.vue"),
  },
  {
    path: "/911",
    name: "911",
    component: () => import("../views/911.vue"),
  },
  {
    path: "/text/:name",
    name: "text",
    component: () => import("../views/Text.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
